import React from 'react';

interface LoadingDotsProps {
  className?: string;
}

export const LoadingDots: React.FC<LoadingDotsProps> = ({ className }) => (
  <span className={`loading-dots ${className ?? ''}`.trim()} aria-hidden="true">
    <span className="loading-dots__dot" />
    <span className="loading-dots__dot" />
    <span className="loading-dots__dot" />
  </span>
);

export default LoadingDots;
